import { Component, OnInit } from '@angular/core';
import { ReportService } from './report.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  dailyReports : any = {};
  weeklyReports: any = {};
  quiriesReports: any = {};

  constructor(private reportService: ReportService) { }

  ngOnInit(): void {
    this.getDailyReports();
    this.getWeeklyReports();
    this.getQuiriesReports();
  }

  getDailyReports(){
    let reports;
    this.reportService.dailyReports(reports).subscribe((dailyreports)=>{
      this.dailyReports = dailyreports.data;
    })
  }

  getWeeklyReports(){
    let reports;
    this.reportService.weeklyReports(reports).subscribe((weeklyreports)=>{
      this.weeklyReports = weeklyreports.data;
    })
  }

  getQuiriesReports(){
    let reports;
    this.reportService.quiriesReports(reports).subscribe((quiriesreports)=>{
      this.quiriesReports = quiriesreports.data;
    })
  }

  downloadDailyReports(){
    let dailyReport;
    this.reportService.downloadDailyReports(dailyReport).subscribe((res) => {
      let resp = res['data']['content'];
      let file = res['data']['filename']
      FileSaver.saveAs(`data:application/vnd.ms-excel;base64,${resp}`, `${file}`);
    })
  }

  downloadMonthlyReports() {
   let monthlyReport;
    this.reportService.downloadMonthlyReports(monthlyReport).subscribe((res) => {
      let resp = res['data']['content'];
      let file = res['data']['filename']
      FileSaver.saveAs(`data:application/vnd.ms-excel;base64,${resp}`, `${file}`);
    })
  }

  downloadQuiryReports() {
    let quiryReport;
     this.reportService.downloadQuiries(quiryReport).subscribe((res) => {
       let resp = res['data']['content'];
       let file = res['data']['filename']
       FileSaver.saveAs(`data:application/vnd.ms-excel;base64,${resp}`, `${file}`);
     })
    }
}
